import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { VisitService } from '../rest_services/visit.service';
import { VisitsService } from '../rest_services/visits.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { SalesService } from '../rest_services/sales.service';
import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-cover-page-ca',
  templateUrl: './cover-page-ca.component.html',
  styleUrls: ['./cover-page-ca.component.css'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class CoverPageCaComponent implements OnInit {

    visitStatisticsSubscription!: Subscription;
    visitStatisticsListSubscription!: Subscription;
    visitStatisticsIndicatorsSubscription!: Subscription;
    constructor(private visitsService:VisitsService, 
                private visitService:VisitService,
                private saleService:SalesService,private cdr: ChangeDetectorRef) { }
      currentYear:number=0;
      loadingCover:boolean=true;
      connectedCompany:any="";
    
      ngOnInit(): void {
        if (window.screen.width <= 768) { // 768px portrait
          this.mobile = true;
          if (window.screen.width > 668) this.medium = true;
        }else {
          this.mobile = false;
        }

        if(localStorage.getItem("comp")!=undefined){
          this.connectedCompany = localStorage.getItem("comp")?.toString();
        }else {
          this.connectedCompany = sessionStorage.getItem("comp")?.toString();
        }
        this.currentYear = new Date().getFullYear();
        this.getCommercials();
        setTimeout(()=>{
          (<any>$('#example')).DataTable( {
            "destroy":true,
            "ordering": false,
            "processing": true,
            "pagingType": "full_numbers",
            // "scrollX": '400px',
            searching: false, paging: false,
            "scrollCollapse": true,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            }
          } );
          $('.dataTables_empty').html('<div _ngcontent-lpv-c73="" class="col-xl-12 col-md-12 col-sm-12 col-12" style="position: absolute;"><ul _ngcontent-lpv-c73="" class="list-inline mb-3 d-flex justify-content-sm-end justify-content-center mr-sm-3 ml-sm-0 mx-3"><li _ngcontent-lpv-c73="" class="list-inline-item align-self-center"><div _ngcontent-lpv-c73="" class="scrollTop"><i _ngcontent-lpv-c73="" class="flaticon-up-arrow-fill-1"></i></div></li></ul></div>');
    
        }, 200);
      }
    //#region COMMERCIALS PERFORMANCE CHARTS
      commercials:any[]=[];
      getCommercials(){
        this.visitService.getCommercialsToAffect();
        this.visitService.commercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code=="b1f37eec383fcada527079602ac178b3"){                 
              this.commercials = data.commercials
              .filter((commercial: any) => commercial.profile !== "981dc265-63b8-45ba-b356-befb5a9a6f74");
              for(var commercial of data.commercials){
                var statsCommercial:any = {id:null,commercial:null,stats:null};
                statsCommercial.commercial =commercial.commercial;
                statsCommercial.id = commercial.commercial_uuid;
                this.getVisitCoverOfCommercial(statsCommercial,commercial, this.commercials.indexOf(commercial));
                $("#nodata-"+data.commercials.indexOf(commercial)).hide();
              }
              this.loadingCover =false;
            }
          },
        )  
      }
      loadingVisitsCover:boolean=false;
      cover:any[any]=[];
      getVisitCoverOfCommercial(commercial:any,objCommercial:any,index:any){
        var totalVisitsGoal = 0;
        var totalVisitsMade = 0;
        this.visitStatisticsSubscription = this.saleService.getSalesStatisticsCover(commercial.id).subscribe(
          (res: any) => {
            if(res.code == "SUCCESS"){
              var statsCommercial:any = {id:commercial.id,commercial:commercial.commercial,stats:[]};
              totalVisitsGoal = res.coverCa.totalTargetsYear;
              var selectedCommercial:any = this.commercials.find((d: any) => d.commercial_uuid === commercial.id);
              if(selectedCommercial!=undefined){
                selectedCommercial.totalVisitsGoal = res.coverCa.totalTargetsYear;
                selectedCommercial.totalVisitsMade = res.coverCa.totalMadeYear;
              }
              totalVisitsMade = res.coverCa.totalMadeYear;
              console.log(selectedCommercial);
              
              statsCommercial.stats =res.coverCa.monthsSales
              this.cover.push(statsCommercial);
              this.initChart(index,objCommercial,totalVisitsGoal,totalVisitsMade);
            }
          },
          (err: any) => {
            console.log(err);
            this.loadingVisitsCover = false;
        });
      };
      getMonthName(monthNumber:number) {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        var month = date.toLocaleString('fr-FR', {
          month: 'long',
        });
        month = month.charAt(0).toUpperCase() + month.slice(1);
        return month;
      }
  
      minimzeCard:boolean=false;
      // COVER PROGRESSION CHARTS
      initChart(index:any,commercial:any,salesTotalTarget:number,salesTotalAchieved:number){
        $("#loading-"+index).hide();
        if(salesTotalTarget==0 && salesTotalAchieved==0){
          $("#nodata-"+index).show();
          // $("#card-com-"+index).addClass("col-lg-2");
          $("#chartdiv"+index).hide();
          this.minimzeCard= true;
        }else {
          // $("#card-com-"+index).addClass("col-lg-4");
          $("#nodata-"+index).hide();
          var chart:any = null;
          if (chart != null) {
            chart.dispose();
            chart = null;
          }
          commercial.goal = salesTotalTarget ;
          commercial.made = salesTotalAchieved;
          if(salesTotalAchieved>=salesTotalTarget/3){
            $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
            $("#imageContent-"+index).addClass("meta-medium")
            $("#background-card-"+index).addClass("fa fa-hand-lizard big-centered-icon-soso");
          }else if(salesTotalAchieved<salesTotalTarget/3){
            $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
            $("#imageContent-"+index).addClass("meta-bad")
            $("#background-card-"+index).addClass("flaticon-like-3 fa-flip-vertical big-centered-icon-bad");
          }else {
            $("#background-card-"+index).removeClass('fa fa-ellipsis-h');
            $("#imageContent-"+index).addClass("meta-good")
            $("#background-card-"+index).addClass("flaticon-like-3 big-centered-icon-good");
          }
          
          am4core.useTheme(am4themes_animated);
          // create chart
          chart = am4core.create("chartdiv"+index, am4charts.GaugeChart);
          chart.numberFormatter.numberFormat = "#,###";
          chart.numberFormatter.bigNumberPrefixes = [];
          chart.numberFormatter.smallNumberPrefixes = [];

          // Forcer le séparateur français
          chart.language.locale["_thousandSeparator"] = " ";
          chart.language.locale["_decimalSeparator"] = ",";
          chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
    
          chart.innerRadius = -25;
    
          let axis = chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
          axis.min = 0;
          axis.max = salesTotalTarget;
          axis.strictMinMax = true;
          axis.renderer.minGridDistance = 55;
          axis.strictMinMax = true;
          axis.renderer.labels.template.bent = false;
          axis.renderer.labels.template.radius = am4core.percent(15);
          axis.renderer.labels.template.padding(0, 0, 0, 0);
          axis.renderer.grid.template.stroke = new am4core.InterfaceColorSet().getFor("background");
          axis.renderer.grid.template.strokeOpacity = 0.3;
    
          let colorSet = new am4core.ColorSet();
    
          let range0:any = axis.axisRanges.create();
          range0.value = 0;
          range0.endValue = salesTotalTarget/3;
          range0.axisFill.fillOpacity = 1;
          range0.axisFill.fill = colorSet.getIndex(0);
          range0.axisFill.zIndex = - 1;
    
          let range1:any = axis.axisRanges.create();
          range1.value = salesTotalTarget/3;
          range1.endValue = salesTotalTarget/3 + salesTotalTarget/3;
          range1.axisFill.fillOpacity = 1;
          range1.axisFill.fill = colorSet.getIndex(2);
          range1.axisFill.zIndex = -1;
    
          let range2:any = axis.axisRanges.create();
          range2.value = salesTotalTarget/3 + salesTotalTarget/3;
          range2.endValue = salesTotalTarget;
          range2.axisFill.fillOpacity = 1;
          range2.axisFill.fill = colorSet.getIndex(4);
          range2.axisFill.zIndex = -1;
          // let hand = chart.hands.push(new am4charts.ClockHand());
          // // using chart.setTimeout method as the timeout will be disposed together with a chart
          // chart.setTimeout(randomValue, 1000);
          // function randomValue() {
          //     var rand = Math.random() * 100;
          //     hand.showValue(salesTotalAchieved, 1000, am4core.ease.cubicOut);
          //     $("#btn-details"+index).show();
          //     setTimeout(()=>{
          //       var legends = Array.from(document.querySelectorAll('g[stroke-width="1.7999999999999998"]'));
                
          //       legends.forEach((legend) => {
          //         legend?.setAttribute("style","display:none !important;")
          //       });
          //     }, 300);
          // }
          let hand = chart.hands.push(new am4charts.ClockHand());

          // Vérifier si l'objectif est dépassé
          const isExceeded = salesTotalAchieved > salesTotalTarget;
          const displayValue = isExceeded ? salesTotalTarget : salesTotalAchieved;

          chart.setTimeout(randomValue, 1000);

          function randomValue() {
            hand.showValue(displayValue, 1000, am4core.ease.cubicOut);
            $("#btn-details" + index).show();

            setTimeout(() => {
                var legends = Array.from(document.querySelectorAll('g[stroke-width="1.7999999999999998"]'));
                legends.forEach((legend) => {
                    legend?.setAttribute("style", "display:none !important;");
                });
          }, 300);
}
        }
      }
    //#endregion
    
    //#region DETAILS TABLE COMMERCIAL
      coverDetail:any[]=[];
      totalGoalYear:number=0;
      totalMadYear:number=0;
      months:any[]=[];

      loading: boolean = false;
      errorMessage: string = '';
      loadingIndicatorsGlobalCovers:boolean=false;
  
      mobile:boolean=false;medium:boolean=false;

      // Données du tableau
      monthlyStats: any[] = [];
      totalObjective: number = 0;
      totalRealized: number = 0;
      totalToRecover: number = 0;
      totalPotential: number = 0;
      overallPercentage: number = 0;
      selectedCommercial: string="";
      selectedFullnameCommercial:any="- - -";
      selectedCommercialUrl:any=null;
      currentMonth: number = new Date().getMonth() + 1; // 1-12
      getDetailsCoverCommercial(commercial:any){
        this.loading = true;
        this.selectedCommercial = commercial; 
        var selectedCommercial:any = this.commercials.find((d: any) => d.commercial_uuid === commercial);        
        this.selectedFullnameCommercial = selectedCommercial.commercial;
        this.selectedCommercialUrl = selectedCommercial.commercial.replace(/\s+/g, '_');

        $('html, body').animate({
          scrollTop: $("#bloc-detail-cover")?.offset()?.top
        }, 2000);
        $("#bloc-detail-cover").addClass("visible")
        this.coverDetail = this.cover.filter((d: any) => d.commercialUuid === commercial);
        this.getDetailsCoverIndicatorsCommercial(commercial);
        this.visitStatisticsListSubscription = this.saleService.getSalesDetailsCover(commercial).subscribe(
        (res: any) => {
          if(res.code == "SUCCESS"){
            this.monthlyStats = res.monthlyStats || [];
            
            // Charger les totaux
            this.totalObjective = res.totalObjective || 0;
            this.totalRealized = res.totalRealized || 0;
            this.totalToRecover = res.totalToRecover || 0;
            this.totalPotential = res.totalPotential || 0;
            this.overallPercentage = res.overallPercentage || 0;
            this.errorMessage = '';
          }else {
            this.errorMessage = res.message || 'Erreur lors du chargement des données';
            console.error('❌ Error loading revenue data:', res.message);
          }
          this.loading = false;
        },
        (err: any) => {
          this.loading = false;
          this.errorMessage = 'Erreur de connexion au serveur. Veuillez réessayer.';
          console.error('❌ HTTP Error:', err);
        });
      }
      getPercentageClass(percentage: number): string {
        if (percentage >= 100) {
          return 'excellent';
        } else if (percentage >= 90) {
          return 'high';
        } else if (percentage >= 75) {
          return 'medium';
        } else {
          return 'low';
        }
      }
      getIndicatorIcon(indicator: string): string {
        switch (indicator) {
          case 'success':
            return '↗';
          case 'up':
            return '→';
          case 'down':
            return '↘';
          default:
            return '→';
        }
      }
      isCurrentMonth(monthNumber: number): boolean {
        return monthNumber === this.currentMonth;
      }

      /**
       * Change le commercial sélectionné et recharge les données
       */
      onCommercialChange(commercial: string): void {
        this.selectedCommercial = commercial;
        this.getDetailsCoverCommercial(this.selectedCommercial);
      }

      /**
       * Rafraîchir les données
       */
      refreshData(): void {
        this.getDetailsCoverCommercial(this.selectedCommercial);
      }
    //#endregion

    //#region INDICATORS COMMERCIAL
      totalSales :any;
      totalRevenue :any;
      successfulClients :any;
      delayedClients:any;
      totalSalesCount:any=0;
      totalRevenues:any=0
      loading_central_indicators:boolean=false;
      
      getDetailsCoverIndicatorsCommercial(commercial:any){
        this.loading_central_indicators=true;
        this.saleService.getSalesDetailsIndicators(commercial).subscribe(
          (res: any) => {
            if (res.code == "SUCCESS" || res.code == "200") {
              console.log(res);
              
              // Extraire les données de l'API
              const monthlyData = res.monthlyChartData || [];
              
              // Préparer les données pour Sparkline
              const barData: number[][] = [];
              const lineData: number[] = [];

              monthlyData.forEach((data: any) => {
                // Pour les barres: [salesCount, revenue/1000]
                // On divise le revenue par 1000 pour adapter l'échelle
                const revenueScaled = (data.revenue || 0);
                barData.push([data.salesCount || 0, revenueScaled]);

                // Pour la ligne: nombre de ventes
                lineData.push(data.salesCount || 0);
              });

              // Créer le graphique après un court délai
              setTimeout(() => {
                // Détruire le graphique existant
                (<any>$('#ry-chart')).empty();
                const barLabels = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];
                if (this.mobile) {
                  // Version mobile
                  (<any>$("#ry-chart")).sparkline(barData, {
                    type: 'bar',
                    height: '90',
                    width: 85,
                    barWidth: 8,
                    barSpacing: 4,
                    zeroAxis: false,
                    barColor: '#1abc9c',
                    stackedBarColor: ['#00d1c1', '#1abc9c'],
                    tooltipFormatter: function(sparkline: any, options: any, fields: any) {
                      const monthLabel = barLabels[fields.offset] || 'Mois';
                      return '<div style="padding: 8px; background: rgba(0,0,0,0.85); color: white; border-radius: 4px; font-family: Calibri, sans-serif;">' +
                            '<strong>' + monthLabel + '</strong><br>' +
                            'Objectif: <strong>' + fields.y.toLocaleString('fr-FR') + ' MAD</strong>' +
                            '</div>';
                    }
                  });
                  
                  (<any>$("#ry-chart")).sparkline(lineData, {
                    type: 'line',
                    fillColor: null,
                    lineWidth: 1.1,
                    spotRadius: 2.5,
                    lineColor: '#3498db',
                    composite: true,
                    tooltipFormatter: function(sparkline: any, options: any, fields: any) {
                      const monthLabel = barLabels[fields.x] || 'Mois';
                      return '<div style="padding: 8px; background: rgba(52, 152, 219, 0.9); color: white; border-radius: 4px; font-family: Calibri, sans-serif;">' +
                            '<strong>' + monthLabel + '</strong><br>' +
                            'Réalisé: <strong>' + fields.y.toLocaleString('fr-FR') + ' MAD</strong>' +
                            '</div>';
                    }
                  });
                } else {
                  // Version desktop
                  (<any>$("#ry-chart")).sparkline(barData, {
                    type: 'bar',
                    height: '90',
                    width: 110,
                    barWidth: 10,
                    barSpacing: 4,
                    zeroAxis: false,
                    barColor: '#1abc9c',
                    stackedBarColor: ['#00d1c1', '#1abc9c']
                  });
                  (<any>$("#ry-chart")).sparkline(lineData, {
                    type: 'line',
                    fillColor: null,
                    lineWidth: 1.4,
                    spotRadius: 2.5,
                    lineColor: '#3498db',
                    composite: true
                  });
                }
              }, 100); // Réduit à 100ms au lieu de 1000ms

              // Mettre à jour les autres indicateurs
              this.totalSales = res.totalSales || 0;
              this.totalRevenue = res.totalRevenue || 0;
              this.successfulClients = res.successfulClients || 0;
              this.delayedClients = res.delayedClients || 0;
              // Calcul du total des ventes (salesCount)
              this.totalSalesCount =res.totalSales || 0;

              // Calcul du total des revenus (revenue)
              this.totalRevenues = res.totalRevenue || 0;
            } else {
              this.errorMessage = res.message || 'Erreur lors du chargement des données';
            }
            this.loading_central_indicators=false;
          },
          (err: any) => {
            this.loading = false;
            this.errorMessage = 'Erreur de connexion au serveur. Veuillez réessayer.';
            console.error('❌ HTTP Error:', err);
          });

      }
    //#endregion

    //#region EXPORT TABLE
      exportToExcel(): void {
        // Créer le contenu HTML du tableau avec style Calibri
        let tableHtml = `
            <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
            <head>
                <meta charset="utf-8">
                <!--[if gte mso 9]>
                <xml>
                    <x:ExcelWorkbook>
                        <x:ExcelWorksheets>
                            <x:ExcelWorksheet>
                                <x:Name>Statistiques</x:Name>
                                <x:WorksheetOptions>
                                    <x:DisplayGridlines/>
                                </x:WorksheetOptions>
                            </x:ExcelWorksheet>
                        </x:ExcelWorksheets>
                    </x:ExcelWorkbook>
                </xml>
                <![endif]-->
                <style>
                    table {
                        font-family: Calibri, sans-serif;
                        font-size: 11pt;
                        border-collapse: collapse;
                    }
                    .brand-row {
                        color: #4a7862 !important;
                    } 
                    th {
                        background-color: #4472C4 !important;
                        color: white;
                        font-weight: bold;
                        padding: 8px;
                        text-align: left;
                        border: 1px solid #000;
                    }
                    td {
                        padding: 8px;
                        border: 1px solid #000;
                    }
                    .total-row {
                        font-weight: bold;
                        background-color: #D9E1F2;
                    }
                    .title-row {
                      background-color: #4472C4 !important;
                      color: white;
                      font-weight: bold;
                      font-size: 14pt;
                      padding: 12px;
                      text-align: center;
                      border: 1px solid #000;
                    }
                </style>
            </head>
            <body>
            <table>
                <thead>
                    <tr>
                      <th class="brand-row">
                          .:: MASTERFIELD ::.
                      </th>
                      <th colspan="6" class="title-row">Statistiques ${this.currentYear} - ${this.selectedFullnameCommercial}</th>
                    </tr>
                    <tr>
                        <th>Mois</th>
                        <th>Objectif (MAD)</th>
                        <th>Réalisé (MAD)</th>
                        <th>À récupérer (MAD)</th>
                        <th>Réalisé (%)</th>
                        <th>Potentiel (MAD)</th>
                        <th>Indicateur</th>
                    </tr>
                </thead>
                <tbody>
        `;

        // Ajouter les lignes de données
        this.monthlyStats.forEach(stat => {
            tableHtml += `
                <tr>
                    <td>${stat.month}</td>
                    <td>${stat.objective.toFixed(2)}</td>
                    <td>${stat.realized.toFixed(2)}</td>
                    <td>${stat.toRecover.toFixed(2)}</td>
                    <td>${stat.percentage.toFixed(2)}</td>
                    <td>${stat.potential.toFixed(2)}</td>
                    <td>${this.getIndicatorText(stat.indicator)}</td>
                </tr>
            `;
        });

        // Ajouter la ligne de total
        tableHtml += `
                <tr class="total-row">
                    <td>Total</td>
                    <td>${this.totalObjective.toFixed(2)}</td>
                    <td>${this.totalRealized.toFixed(2)}</td>
                    <td>${this.totalToRecover.toFixed(2)}</td>
                    <td>${this.overallPercentage.toFixed(2)}</td>
                    <td>${this.totalPotential.toFixed(2)}</td>
                    <td></td>
                </tr>
            </tbody>
            </table>
            </body>
            </html>
        `;

        // Créer le fichier Excel
        const blob = new Blob([tableHtml], {
            type: 'application/vnd.ms-excel;charset=utf-8'
        });

        // Créer un lien de téléchargement
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.href = url;
        link.download = `statistiques_${this.selectedCommercial}_${new Date().getTime()}.xls`;
        link.click();

        // Nettoyer
        URL.revokeObjectURL(url);
    }

    // Méthode helper pour convertir l'indicateur en texte
    getIndicatorText(indicator: string): string {
        switch(indicator) {
            case 'success':
            case 'good':
                return '<span style="color:green;">✓</span>';
            case 'warning':
                return '<span style="color:orange;">⚠</span>';
            case 'danger':
            case 'bad':
                return '<span style="color:#9b3342;">✗</span>';
            default:
                return '-';
        }
    }
    getSurplus(com: any): number {
      return Number(com?.totalVisitsMade || 0) - Number(com?.totalVisitsGoal || 0);
    }
}
